module.exports = __webpack_public_path__ + "static/media/open_map_button_icon.f93cc5cb.svg";